<template>
  <div class="dashboard-panel flex items-center gap-4 relative overflow-hidden">
    <div class="w-12 h-12 rounded-xl flex items-center justify-center shrink-0" :class="iconBgClass">
      <svg class="w-6 h-6" :class="iconColorClass" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path v-if="icon === 'developments'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        <path v-else-if="icon === 'workstreams'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6 4h3" />
        <path v-else-if="icon === 'on-track'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        <path v-else-if="icon === 'at-risk'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        <path v-else-if="icon === 'delayed'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    </div>
    <div>
      <p class="text-sm font-medium text-gray-500 uppercase tracking-wide">{{ label }}</p>
      <p class="text-3xl font-bold mt-1" :class="valueClass">{{ value }}</p>
    </div>
    <div class="absolute right-0 top-0 w-1 h-full" :class="accentClass"></div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  label: { type: String, required: true },
  value: { type: Number, required: true },
  type: { type: String, default: 'default' }
})

const icon = computed(() => {
  switch (props.label) {
    case 'Total Developments': return 'developments'
    case 'Total Workstreams': return 'workstreams'
    case 'On Track': return 'on-track'
    case 'At Risk': return 'at-risk'
    case 'Delayed': return 'delayed'
    case 'Delayed Workstreams': return 'delayed'
    default: return 'default'
  }
})

const valueClass = computed(() => {
  switch (props.type) {
    case 'on-track': return 'text-on-track'
    case 'at-risk': return 'text-at-risk'
    case 'delayed': return 'text-delayed'
    default: return 'text-gray-800'
  }
})

const iconBgClass = computed(() => {
  switch (props.type) {
    case 'on-track': return 'bg-emerald-100'
    case 'at-risk': return 'bg-amber-100'
    case 'delayed': return 'bg-red-100'
    default: return 'bg-slate-100'
  }
})

const iconColorClass = computed(() => {
  switch (props.type) {
    case 'on-track': return 'text-emerald-600'
    case 'at-risk': return 'text-amber-600'
    case 'delayed': return 'text-red-600'
    default: return 'text-slate-600'
  }
})

const accentClass = computed(() => {
  switch (props.type) {
    case 'on-track': return 'bg-emerald-500'
    case 'at-risk': return 'bg-amber-500'
    case 'delayed': return 'bg-red-500'
    default: return 'bg-slate-400'
  }
})
</script>
